export const ROLES = { ADMIN: 'admin', OPERATOR: 'operator', VIEWER: 'viewer', REPORTS: 'report-viewer', MONITOR: 'monitor' };
